import React from 'react'
import { Link } from 'react-router-dom'

const Content = () => {
  return (
    <div className="w-full md:w-6/12 mx-auto h-screen flex items-center">
      <div className="py-5 md:py-10 lg:py-32 w-full bg-white lg:rounded h-full lg:h-auto flex items-center">
        <div className="w-full lg:w-2/3 mx-auto text-center">
          <h1 className="text-xl lg:text-3xl mb-5 uppercase">Thank You!</h1>
          <p className="text-sm text-gray-444 mb-10">
            We are currently reviewing your member submission.
          </p>
          <p className="text-sm">
            <Link to="/" className="link underline">Back to KHUB site</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export { Content }
